import { render, staticRenderFns } from "./HealthyManageCore.vue?vue&type=template&id=9916e628&"
import script from "./HealthyManageCore.vue?vue&type=script&lang=js&"
export * from "./HealthyManageCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports